<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper">
				<div class="modal-container">
					<div class="modal-body text-center">
						<slot name="body">
						default body
						</slot>
					</div>
					<div class="modal-footer" v-if="showFooter">
						<slot name="footer">
						
						<template v-if="confirm">

							<div class="row" style="width: auto">
								<div class="flex-center">	
									<a href="#" class="btn btn-rounded mt-2" v-on:click.prevent="$emit('action', 'no')">{{ no }}</a>
									<a href="#" class="btn btn-rounded btn-rounded-primary mt-2" v-on:click.prevent="$emit('action', 'yes')">{{ yes }}</a>
								</div>
							</div>
							
						</template>
						<template v-else>

							<a href="#" class="btn btn-rounded" v-on:click.prevent="$emit('action', 'close')">{{ close }}</a>
							
						</template>
						
						</slot>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	props:{
		confirm: {
			default: false,
			type: Boolean
		},
		yes: {
			default: 'Yes',
			type: String
		},
		no: {
			default: 'No',
			type: String
		},
		close: {
			default: 'Ok',
			type: String
		},
		showFooter: {
			default: true,
			type: Boolean
		}
	}
};
</script>